import { DEFAULT_COORDS } from '../../constants'
import type { ICoords } from './types'

export const safeParseCoords = (value?: string, defaultValue?: ICoords): ICoords => {
  try {
    return value ? JSON.parse(value) : defaultValue || JSON.parse(DEFAULT_COORDS)
  } catch {
    return defaultValue || JSON.parse(DEFAULT_COORDS)
  }
}

export const saveCoords = (value: ICoords) => JSON.stringify(value)
